import React from 'react';
import { IDocument } from '@naviair-utm/node-shared-interfaces';
import { SingleLayout } from '../../Layout';
import { Card } from '../../Card';
import { Document } from '../../Document';
import { IconName } from '../../Icon';

export interface IDocumentViewProps {
	/**Extends {@link IconName} from FontAwesome for list of allowed icon names */
	document: IDocument<IconName>;
}

/**
 * ## DocumentView
 *
 * Loads a single document
 *
 * @example <DocumentView document={doc} />}
 *
 * @param props see {@link IDocumentViewProps}
 * @returns a SingleLayout component and the document rendered within a Card component.
 */
export const DocumentView: React.FC<IDocumentViewProps> = (props) => {
	const doc = props.document;
	return (
		<SingleLayout>
			<Card key={`informationCardDocument_${1}`} fill title={doc.title} icon={doc.icon}>
				<Document {...props.document} />
			</Card>
		</SingleLayout>
	);
};
